var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoLightYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.42773,
    y: 4,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F2C16B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 21C29 21.5304 29.2107 22.0391 29.5858 22.4142C29.9609 22.7893 30.4696 23 31 23C31.5304 23 32.0391 22.7893 32.4142 22.4142C32.7893 22.0391 33 21.5304 33 21C33 20.4696 32.7893 19.9609 32.4142 19.5858C32.0391 19.2107 31.5304 19 31 19C30.4696 19 29.9609 19.2107 29.5858 19.5858C29.2107 19.9609 29 20.4696 29 21ZM32 26.25H30C29.8625 26.25 29.75 26.3625 29.75 26.5V41C29.75 41.1375 29.8625 41.25 30 41.25H32C32.1375 41.25 32.25 41.1375 32.25 41V26.5C32.25 26.3625 32.1375 26.25 32 26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLightYellow);
export default __webpack_public_path__ + "static/media/info_light_yellow.8d67ddbd90739660da652cf203f82b11.svg";
export { ForwardRef as ReactComponent };